import { theme as appTheme } from '#app/theme/theme.js';
import { type ThemeWithMultiColumnLayoutMode } from '#app/types/multiColumnLayoutMode.js';
import { SkeletonLoader } from './SkeletonLoader.js';
import { type SkeletonLoaderProps } from './types.js';
import { forwardRef, type Ref } from 'react';
import { css, styled } from 'styled-components';

/**
 * Note: This component relies on the ThemeWithMultiColumnLayoutMode in the WorkTab
 * - @imbhargav5.
 * Putting this file along with other Skeleton components here and awaiting team feedback on the
 * right place to put it.
 */
const Wrapper = styled.div<{
  isLoading?: boolean;
  theme: ThemeWithMultiColumnLayoutMode;
}>`
  ${({ isLoading = false, theme }) => css`
    background: ${theme.colorsV2.white};
    border-radius: 20px;
    padding: 28px 32px 14px 32px;
    opacity: ${isLoading ? 1 : 0};
    height: ${isLoading ? 'auto' : '0px'};
    max-width: 100%;
    > div > div {
      // No margin on ItemLoader
      margin: 0px;
    }

    svg {
      width: 100%;
    }
  `}
`;

const SkeletonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const NewWorkOpportunitySkeleton = forwardRef(
  (props: SkeletonLoaderProps, ref: Ref<HTMLDivElement>) => (
    <SkeletonContainer>
      <Wrapper isLoading={props.isLoading}>
        <SkeletonLoader
          colorBase={appTheme.colorsV2.white}
          gradientColor1={appTheme.colorsV2.gray05}
          gradientColor2={appTheme.colorsV2.gray30}
          height={260}
          ref={ref}
          width={744}
          {...props}
        >
          <rect
            height="20"
            rx="10"
            ry="10"
            width="106"
            x="0"
            y="6"
          />
          <rect
            height="32"
            rx="16"
            ry="16"
            width="106"
            x="534"
            y="0"
          />
          <circle
            cx="32"
            cy="80"
            r="32"
          />
          <rect
            height="24"
            rx="12"
            ry="12"
            width="106"
            x="80"
            y="51"
          />
          <rect
            height="28"
            rx="14"
            ry="14"
            width="151"
            x="80"
            y="81"
          />
          <rect
            height="32"
            rx="16"
            ry="16"
            width="97"
            x="0"
            y="128"
          />
          <rect
            height="32"
            rx="16"
            ry="16"
            width="97"
            x="105"
            y="128"
          />
          <rect
            height="32"
            rx="16"
            ry="16"
            width="97"
            x="210"
            y="128"
          />
          <rect
            height="20"
            rx="10"
            ry="10"
            width="106"
            x="374"
            y="134"
          />
          <rect
            height="20"
            rx="10"
            ry="10"
            width="106"
            x="488"
            y="134"
          />
          <rect
            height="20"
            rx="10"
            ry="10"
            width="78"
            x="602"
            y="134"
          />
          <rect
            height="48"
            rx="24"
            ry="24"
            width="147"
            x="0"
            y="200"
          />
          <rect
            height="48"
            rx="24"
            ry="24"
            width="147"
            x="533"
            y="200"
          />
        </SkeletonLoader>
      </Wrapper>
    </SkeletonContainer>
  ),
);
